// React
import React from 'react';
import { Controller } from 'react-hook-form';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEBriefArray from './components/PEBriefArray';

const ScenarioBrief = (props) => {
  const { control, formState, setValue } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Scenario(s)" instructions="Using the controls below, please add scenario(s) for the Practical Exercise." />
      <Controller
        control={control}
        name="content.core"
        render={({field}) => <PEBriefArray inputDir={inputDir} {...{control, errors, setValue}} />}
      />
    </div>
  );
};

export default ScenarioBrief;